/**
 * CompositeFieldTypeContent
 *
 * Composite-field-type branch of the sidebar body, rendered by
 * `CompositeFieldSidebarContent`. Resolves the type's default UI layout and
 * routes to `TableModeContent` when the sidebar was opened in table mode and a
 * cell proxy is available, otherwise to `FormModeContent`. Both `onChange` and
 * the cell proxy are read from the module-level sidebar state at render time.
 */

import { FC } from 'react';
import { useCompositeFieldType } from '../useCompositeFieldType';
import { getCellValueProxy, getOnChange } from '../compositeFieldSidebarState';
import { TableModeContent } from './TableModeContent';
import { FormModeContent } from './FormModeContent';

type CompositeFieldTypeContentProps = {
  compositeFieldTypeId: string;
  fieldId: string;
  isFormulaColumn: boolean;
  tableMode: boolean;
};

export const CompositeFieldTypeContent: FC<CompositeFieldTypeContentProps> = ({
  compositeFieldTypeId,
  fieldId,
  isFormulaColumn,
  tableMode,
}) => {
  const compositeFieldType = useCompositeFieldType(compositeFieldTypeId);
  const structure = compositeFieldType?.defaultUILayout?.structure;
  const onChange = getOnChange();
  const cellProxy = getCellValueProxy();

  if (tableMode && cellProxy) {
    return (
      <TableModeContent
        cellProxy={cellProxy}
        compositeFieldTypeId={compositeFieldTypeId}
        fieldId={fieldId}
        isFormulaColumn={isFormulaColumn}
        onChange={onChange}
        structure={structure}
      />
    );
  }

  return (
    <FormModeContent
      compositeFieldTypeId={compositeFieldTypeId}
      fieldId={fieldId}
      isFormulaColumn={isFormulaColumn}
      onChange={onChange}
      structure={structure}
    />
  );
};
